import { render, staticRenderFns } from "./SourceListToPartner.vue?vue&type=template&id=4797a495"
import script from "./SourceListToPartner.vue?vue&type=script&lang=ts"
export * from "./SourceListToPartner.vue?vue&type=script&lang=ts"
import style0 from "./SourceListToPartner.vue?vue&type=style&index=0&id=4797a495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports